import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { repairSettingsApi } from './repair-settings.api';
import { repairSettingsKeys } from './repair-settings.queries';

function invalidate(qc: ReturnType<typeof useQueryClient>) {
  qc.invalidateQueries({ queryKey: repairSettingsKeys.all });
}

export function useStoreRepairReasonMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      destId,
      data
    }: {
      destId: number;
      data: Parameters<typeof repairSettingsApi.storeReason>[1];
    }) => repairSettingsApi.storeReason(destId, data),
    onSuccess: () => invalidate(qc)
  });
}

export function useUpdateRepairReasonMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      data
    }: {
      id: number;
      data: Parameters<typeof repairSettingsApi.updateReason>[1];
    }) => repairSettingsApi.updateReason(id, data),
    onSuccess: () => invalidate(qc)
  });
}

export function useUpdateRepairDestinationMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      data
    }: {
      id: number;
      data: Parameters<typeof repairSettingsApi.updateDestination>[1];
    }) => repairSettingsApi.updateDestination(id, data),
    onSuccess: () => invalidate(qc)
  });
}

export function useDeleteRepairReasonMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: repairSettingsApi.deleteReason,
    onSuccess: () => {
      toast.success('Reason deleted.');
      invalidate(qc);
    }
  });
}
